import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaAdmissionData } from "@/src/types/admissionOffice";

const AOPMaltaAdmissionLayout = () => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaAdmissionData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "01",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    coursePrefix: "",
    body: [],
    invoiceBody: [],
  });

  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaAdmissionData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "01",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    coursePrefix: "",
    body: [],
    invoiceBody: [],
  });

  return (
    <>
      <div className="container admission-office-page">
        <AOPConfig dataForGeneration={dataForGeneration} setDataForGeneration={setDataForGeneration} setBodyForPrev={setBodyForPrev} />
        <AOPPrev bodyForPrev={bodyForPrev} />
      </div>
    </>
  );
};

export default AOPMaltaAdmissionLayout;
